import graphql__af7cf99986e2d60503fd from "./__generated__/TerminateSubscriptionDialog_subscription.graphql.ts";
import graphql__0cca0845a2de9f50da70 from "./__generated__/TerminateSubscriptionDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import FormDialog from "../dialog/FormDialog";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useIntl} from "react-intl";

type TerminateSubscriptionDialogProps = {
    queryRef: any,
    handleCloseDialog: () => {}
}

const TerminateSubscriptionDialog: React.FC<TerminateSubscriptionDialogProps> = (props) => {

    const intl = useIntl();
    const subscription = useFragment(
        graphql__af7cf99986e2d60503fd,
        props.queryRef
    );

    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__0cca0845a2de9f50da70,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    props.handleCloseDialog();
                },
                onError: (error) => {
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToTerminateSubscription'})
            }
        )
    }

    return (
        <FormDialog handleCloseDialog={props.handleCloseDialog}
                    handleSubmission={handleSubmission}
                    initialValues={{id: subscription.id}}
                    headline={intl.formatMessage({id: 'dialog.TerminateSubscriptionDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'dialog.TerminateSubscriptionDialog.submitLabel'})}
                    dangerous={true}>
            <Section>
                <Row>
                    <div className="text-gray-900 font-medium">
                        {intl.formatMessage({id: 'dialog.TerminateSubscriptionDialog.confirmMessage'}, {
                            service: subscription.subscriptionService.name,
                            reference: subscription.subscriptionServiceReferenceLabel
                        })}
                    </div>
                </Row>
                <Row>
                    {intl.formatMessage({id: 'dialog.TerminateSubscriptionDialog.hint'}, {
                        customer: subscription.customerAccount.customerName
                    })}
                </Row>
            </Section>
        </FormDialog>
    )
}

export default TerminateSubscriptionDialog;
